import React, {PureComponent} from "react"
import {LoginActiveSession} from "@irati/types"
import {Label1, Label2, Label4} from "@irati/ui/src/Labels"
import sessionService from "@irati/auth/services/login"
import FormattedMessage, {FormattedDate} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {TextButton} from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"

import {StyledCard, Flex, FlexLeft, FlexRight, CurrentSession} from "./styled"

interface Props {
  session: LoginActiveSession
}

interface State {
  delete?: Promise<any>
}

export default class Security extends PureComponent<Props, State> {
  state: State = {}

  parseUserAgent(session: LoginActiveSession) {
    try {
      const {browser, os, ip} = JSON.parse(session.userAgent)

      return {ip, os, browser}
    } catch (e) {
      return {ip: "unknown", browser: "unknown", os: "unknown"}
    }
  }

  lastActive(session: LoginActiveSession) {
    return session.refreshedAt || session.createdAt
  }

  handleRemove = () => {
    const {session} = this.props
    this.setState({delete: sessionService.removeActiveSession(session.uuid)})
  }

  render() {
    const {session} = this.props
    const {ip, browser, os} = this.parseUserAgent(session)

    return (
      <StyledCard tiny>
        {session.isCurrent && (
          <CurrentSession>
            <FormattedMessage id="account.security.sessions.current" />
          </CurrentSession>
        )}
        <Flex>
          <FlexLeft>
            <Label1>{os}</Label1>
            <Label2>{browser}</Label2>
            <Label4>ip: {ip}</Label4>
            <Label4>
              Last Active: <FormattedDate value={this.lastActive(session)} />
            </Label4>
          </FlexLeft>
          <FlexRight>
            <Loading load={this.state.delete}>
              <TextButton onClick={this.handleRemove} marginRight>
                <Icon icon={IconTypes.bin} />
              </TextButton>
            </Loading>
          </FlexRight>
        </Flex>
      </StyledCard>
    )
  }
}
